import { Tabs } from '@mantine/core';
import { DatesRangeValue } from '@mantine/dates';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Conversation } from '@/components/Conversation';
import ContainerHeader from '@/components/Headers/ContainerHeader';
import { Overview } from '@/components/Records/Overview';
import TeachModel from '@/components/TeachModel';
import Unanswered from '@/components/Unanswered';
import MessageHistory from '@/components/MessageHistory';

const sevenDaysAgo = new Date();
sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
sevenDaysAgo.setHours(0, 0, 0, 0);

const today = new Date();
today.setHours(23, 59, 59, 999);

dayjs.extend(utc);

const Records = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string | null>('history');
  const [dateRange, setDateRange] = useState<DatesRangeValue>([sevenDaysAgo, today]);
  const [rangeDateTimeText, setRangeDateTimeText] = useState('');

  const handleDateRangeChange = (date: DatesRangeValue) => {
    setDateRange(date);
  };

  return (
    <>
      <ContainerHeader title={t('page.chat_history_title')} />
      <Overview
        dateRange={dateRange}
        onDateRangeChange={handleDateRangeChange}
        rangeDateTimeText={rangeDateTimeText}
        setRangeDateTimeText={setRangeDateTimeText}
      />
      <Tabs value={activeTab} onChange={setActiveTab} className="mt-10">
        <Tabs.List className="rounded-lg mb-4">
          <Tabs.Tab value="history" className="">
            {t('chat_history.tab.history')}
          </Tabs.Tab>
          <Tabs.Tab value="feedback" className="">
            {t('chat_history.tab.feedback')}
          </Tabs.Tab>
          <Tabs.Tab value="unanswerable" className="">
            {t('chat_history.tab.unanswerable')}
          </Tabs.Tab>
          <Tabs.Tab value="message_history" className="">
            {t('chat_history.tab.message_history')}
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="history">
          {activeTab === 'history' && (
            <Conversation
              dateRange={dateRange}
              onDateRangeChange={handleDateRangeChange}
              setRangeDateTimeText={setRangeDateTimeText}
            />
          )}
        </Tabs.Panel>
        <Tabs.Panel value="feedback">
          {activeTab === 'feedback' && (
            <TeachModel
              dateRange={dateRange}
              onDateRangeChange={handleDateRangeChange}
              setRangeDateTimeText={setRangeDateTimeText}
            />
          )}
        </Tabs.Panel>
        <Tabs.Panel value="unanswerable">
          {activeTab === 'unanswerable' && (
            <Unanswered
              dateRange={dateRange}
              onDateRangeChange={handleDateRangeChange}
              setRangeDateTimeText={setRangeDateTimeText}
            />
          )}
        </Tabs.Panel>
        <Tabs.Panel value="message_history">
          {activeTab === 'message_history' && (
            <MessageHistory
              dateRange={dateRange}
              onDateRangeChange={handleDateRangeChange}
              setRangeDateTimeText={setRangeDateTimeText}
            />
          )}
        </Tabs.Panel>
      </Tabs>
    </>
  );
};

export default Records;
